import "../Challenges.css"
import React, { useState,useEffect } from "react";
import api from "views/auth/Api";
import "../../myProjects/Myprojects.css"
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import Challengestable from "../../tables/components/Challengestable";
import {columnsChallenges} from "../../tables/variables/columnsData";




const ChallengeDeAssigned = () => {

        const [data , setData] = useState([]);
        const [current , setCurrent] = useState("overview");
        const { id } = useParams();
        const navigate = useNavigate();
        const [tableData, setTableData] = useState([]);
        const [challangePoints, setChallangePoints] = useState('');


           
     useEffect(() => {
     api.get(`${API_BASE_URL}assigned-challenge/${id}`)
      .then((response) => {  
        if (!response.data) {
          navigate(`/auth/not-found/`);
        }
        setData(response.data);
        setTableData(response.data.submission);
        setChallangePoints(response.data.points);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [navigate,id]);

  const setNew = (newData) => {
    setTableData(newData);
  }

const MyComponent=({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
}

  
  return (
    <div>
      <div className="create-header">
        <div className="Challenge-NameInfo">
        <h2>{data.challenge?.challengeTitle}</h2>
        <div className="remaining-points">
         <p>{data.challenge?.subject}</p>
          <p>Grade {data.challenge?.grade}  </p>
          { data.challenge?.voxel ? <span> VOXEL </span> : <span>{ data.teacher?.name} - {data.teacher?.school?.name} </span> }
        </div>
        <div className="headerLinks mt-[10px]">
        <div className="headerLink" onClick={() => setCurrent("overview")}> <span className={current==="overview" ? "active" : "noActive"}>Overview</span>
        </div>
        <div className="headerLink" onClick={() => setCurrent("subFeed")}> <span className={current==="subFeed" ? "active" : "noActive"}>Submission & Feedback</span>
        </div>
         </div>
          </div>
      </div>
      {current === "overview" ? 
      <div>
           <div className="challangeInstr">
            <div className="pCreate">
            <div className="challangePic" style={{backgroundImage:`url(${FILES_URL}${data.challenge?.coverImg?.url})`}}></div>
            <div className="flex gap-[20px]" >
             <div className="lRCreate">
             <h4 className="h4Create">Challenge Theme : </h4>
                     <MyComponent htmlContent={data.challenge?.requirement?.theme}/>
     <h4 className="h4Create">Mission : </h4>
                     <MyComponent htmlContent={data.challenge?.requirement?.mission}/>
     <h4 className="h4Create">Design & Submission Guidelines : </h4>
                     <MyComponent htmlContent={data.challenge?.requirement?.designSubmission}/>
     </div>
     <div className="lRCreate">
     <h4 className="h4Create">Judging Criteria : </h4> 
                     <MyComponent htmlContent={data.challenge?.requirement?.judgingCriteria}/>
     <h4 className="h4Create">Terms & Conditions : </h4> 
                     <MyComponent htmlContent={data.challenge?.requirement?.termsConditions}/>
     <h4 className="h4Create">Nutshell : </h4> 
                     <MyComponent htmlContent={data.challenge?.requirement?.nutshell}/>
     </div>
     </div>
      </div>
           </div>
           {/* <div className="challengeVideo">
           <video width="1000px" height="500" controls className="videoEdit">
       <source src="movie.mp4" type="video/mp4"/>
       <source src="movie.ogg" type="video/ogg"/>
     Your browser does not support the video tag.
     </video>
           </div> */}
           <div className="challengeVideo">
 <iframe
        src={data.challenge?.videoUrl}
        style={{ border: 0, width: "1000px", height: "500px" }}
        allowFullScreen
        allow="encrypted-media"
        title="VdoCipher Video"
        className="videoEdit"
      ></iframe>     
      </div>

      </div> : current === "subFeed" ?
      <Challengestable columnsData={columnsChallenges}
                          table={tableData}
                          assignId={data.id}
                          setNew={setNew}
                          challangePoints={challangePoints}
                          /> : null}
  {/* {assign? <ChallengesAssign popUpAssign={popUpAssign} onClose={onClose} /> : null} */}
    </div>
  );
};

export default ChallengeDeAssigned;
